import React, {useEffect, useState} from 'react'
import { getCurrentUser } from '../utils/auth'
import {format} from 'date-fns'
import "./Customers.css"
import { useNavigate } from "react-router-dom"
import { BsFillPencilFill, BsFillTrashFill, BsFileTextFill, BsTable, BsFilePersonFill } from 'react-icons/bs'
import ModalCustomerEdit from "./ModalCustomerEdit"
import ModalCustomerSessions from './ModalCustomerSessions'
import ModalCustomerClients from './ModalCustomerClients'
import ModalCustomerNotes from './ModalCustomerNotes'
import Caret from './Icon/Caret'
import { Link } from 'react-router-dom'

const buildProtocolOption = (item) => {
    const protocolId = Number(item?.protocol?.protocol_id ?? item?.protocol_id ?? item?.id ?? 0);
    const protocolName = String(item?.protocol?.name ?? item?.name ?? item?.description ?? '').trim();
    const protocolTypeDescription = String(
        item?.protocol?.protocol_type?.description
        ?? item?.protocol?.protocol_type_description
        ?? item?.protocol_type?.description
        ?? item?.protocol_type_description
        ?? ''
    ).trim();

    return {
        description: protocolName,
        dropdownLabel: protocolTypeDescription ? `${protocolName} (${protocolTypeDescription})` : protocolName,
        selectionKey: `${protocolName}::${protocolId}`,
        id: protocolId,
    };
}

const Customers = ({deleteRow}) => {
    const tokenPayload = getCurrentUser() || {};
    const navigate = useNavigate();
    const permissionScope = 'customerData'
    const fetchAllCustomersUrl = process.env.REACT_APP_API_URL_BASE + '/customers/view'
    const fetchSingleCustomerUrl = process.env.REACT_APP_API_URL_BASE + '/customers/customer/*id*/view'
    const fieldsNoSort = ["Info", "Active", "Authorized", "Actions"]
    const headers = [
        {
            id: 0,
            KEY: "info",
            LABEL: "Info",
            CLASS: "icons-width"
        },
        {
            id: 1,
            KEY: "customer_id",
            LABEL: "ID",
            CLASS: "left"
        },
        {
            id: 2,
            KEY: "customer_name",
            LABEL: "Customer",
            CLASS: "left"
        },
        {
            id: 3,
            KEY: "description",
            LABEL: "Type",
            CLASS: "left"
        },
        {
            id: 4,
            KEY: "contact_name",
            LABEL: "Contact",
            CLASS: "left"
        },
        {
            id: 5,
            KEY: "contact_email",
            LABEL: "Email",
            CLASS: "left"
        },
        {
            id: 6,
            KEY: "is_active",
            LABEL: "Active",
            CLASS: ""
        },
        {
            id: 7,
            KEY: "is_authorized",
            LABEL: "Authorized",
            CLASS: ""
        },
        {
            id: 8,
            KEY: "created_on",
            LABEL: "Customer Since",
            CLASS: "left"
        },
        {
            id: 9,
            KEY: "actions",
            LABEL: "Actions",
            CLASS: "left"
        }
    ]

    const [customerEdit, setCustomerEdit] = useState(null);
    const [customerIdSessions, setCustomerIdSessions] = useState(null);
    const [customerInfo, setCustomerInfo] = useState(null);
    const [editedRecord, setEditedRecord] = useState(null);
    const [isNewCustomer, setIsNewCustomer] = useState(false);
    const [modalNotes, setModalNotes] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [isReadOnlyModal, setIsReadOnlyModal] = useState(false);
    const [modalSessions, setModalSessions] = useState(false);
    const [modalClients, setModalClients] = useState(false);
    const [allCustomerTypes, setAllCustomerTypes] = useState(null);
    const [allSportTeams, setAllSportTeams] = useState(null);
    const [allProtocols, setAllProtocols] = useState(null);
    const [records, setRecords] = useState([]);
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [showRemoved, setShowRemoved] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [sort, setSort] = useState({ keyToSort: "customer_name", direction: "asc"});

    const normalizedSearchText = searchText.trim().toLowerCase();

    const matchesSearch = (record) => {
        if (!normalizedSearchText) {
            return true;
        }

        const searchableValues = [
            record.id,
            record.customer_name,
            record.description,
            record.contact_name,
            record.contact_email,
        ];

        return searchableValues
            .filter((value) => value !== null && value !== undefined)
            .some((value) => String(value).toLowerCase().includes(normalizedSearchText));
    };

    const visibleRecords = records
        .map((record, recordIndex) => ({ record, recordIndex }))
        .filter(({ record }) => (showRemoved || record.is_active !== false) && matchesSearch(record));


    const fetchAllCustomerData = async () => {
        setIsTableLoading(true);
        try{
            const response = await fetch(fetchAllCustomersUrl,
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(json);
        } catch (error) {
            console.error(error);
        } finally {
            setIsTableLoading(false);
        }
    }

    const fetchSingleCustomerData = async (customer_id) => {
        try{
            const response = await fetch(fetchSingleCustomerUrl.replace("*id*", customer_id),
                {
                    method: 'GET',
                    headers: {
                        'machine':'2',
                        'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                    },
                });
            if (!response.ok) {
                throw new Error(`Fetch error - ${response.url} - Status: ${response.status}`);
            }
            const json = await response.json();
            setRecords(originalRecords => {
                const newRecords = [...originalRecords];
                newRecords[editedRecord] = json[0];
                return newRecords;
            });
        } catch (error) {
            console.error(error);
        }
    }

    const fetchAllCustomerTypes = async () => {
        fetch(process.env.REACT_APP_API_URL_BASE + '/customer_types/',
        {
            method: 'GET',
            headers: {
                'machine':'2',
                'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
            },
        })
        .then(res => res.json())
        .then(data => {
            const customerOptions = data.map(item => ({ description: item.description, id: item.customer_type_id }));
            setAllCustomerTypes(customerOptions)
        })
        .catch(error => console.error(error));
    }

    const fetchAllProtocols = async () => {
        fetch(process.env.REACT_APP_API_URL_BASE + '/protocols/view/active',
        {
            method: 'GET',
            headers: {
                'machine':'2',
                'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
            },
        })
        .then(res => res.json())
        .then(data => {
            const protocols = data.map(item => buildProtocolOption(item));
            setAllProtocols(protocols)
        })
        .catch(error => console.error(error));
    }

    const fetchAllSportTeams = async () => {
        fetch(process.env.REACT_APP_API_URL_BASE + '/sport_teams/',
        {
            method: 'GET',
            headers: {
                'machine':'2',
                'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
            },
        })
        .then(res => res.json())
        .then(data => {
            const sportTeamOptions = data.map(item => ({ description: item.team_name, id: item.sport_team_id }));
            setAllSportTeams(sportTeamOptions)
        })
        .catch(error => console.error(error));
    }

    useEffect(() => {
        if (!window.sessionStorage.getItem("auth") || !(tokenPayload.scopes || []).includes('read:' + permissionScope)) {
            navigate('/unauthorized')
        }

        if (editedRecord !== null) {
            fetchSingleCustomerData(records[editedRecord].id);
            setEditedRecord(null)
        }
        else {
            // pull all Customers
            fetchAllCustomerData();
        }
        fetchAllCustomerTypes();
        fetchAllSportTeams();
        fetchAllProtocols();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleHeaderClick(header) {
        if (!fieldsNoSort.includes(header.LABEL)) {
            const nextDirection =
                header.KEY === sort.keyToSort
                    ? (sort.direction === 'asc' ? 'desc' : 'asc')
                    : 'asc';

            const nextSort = {
                keyToSort: header.KEY,
                direction: nextDirection,
            };

            setSort(nextSort);
            setRecords((originalRecords) => {
                const sortedData = [...originalRecords].sort((a, b) => {
                    const aValue = a[nextSort.keyToSort];
                    const bValue = b[nextSort.keyToSort];

                    if (aValue === null || aValue === undefined) return 1;
                    if (bValue === null || bValue === undefined) return -1;

                    const aComparable = String(aValue).toLowerCase();
                    const bComparable = String(bValue).toLowerCase();

                    if (nextSort.direction === 'asc') {
                        return aComparable.localeCompare(bComparable);
                    }

                    return bComparable.localeCompare(aComparable);
                });

                return sortedData;
            });
        }
    }

    const handleCustomerEdit = (customerInfo, recordIndex) => {
        // edit customer info icon clicked
        // set the record in order to do a refresh on the edited customer
        setEditedRecord(recordIndex)
        setCustomerEdit(customerInfo)
        setIsNewCustomer(false);
        setIsReadOnlyModal(false);
        setModalEdit(true);
      };

    const handleCustomerView = (customerInfo, event) => {
        if (event.target.closest('.actions-cell') || event.target.closest('.info-cell')) {
            return;
        }

        setCustomerEdit(customerInfo);
        setIsNewCustomer(false);
        setIsReadOnlyModal(true);
        setModalEdit(true);
    };

    const handleViewSessions = (customerInfo) => {
        // View Sessions icon clicked
        setIsNewCustomer(false);
        setCustomerInfo(customerInfo);
        setCustomerIdSessions(customerInfo.id);
        setModalSessions(true);
    }

    const handleViewCustomers = (customerInfo) => {
        setCustomerInfo(customerInfo);
        setCustomerIdSessions(customerInfo.id);
        setModalClients(true);
    }

    const handleViewNotes = (customerInfo) => {
        // Notes icon clicked
        setIsNewCustomer(false);
        setCustomerInfo(customerInfo);
        setModalNotes(true);
    }

    const handleDeleteCustomer = async (customerInfo, recordIndex) => {
        // Delete icon clicked: set customer inactive
        if (canDeleteRecords) {
            try {
                const response = await fetch(process.env.REACT_APP_API_URL_BASE + '/customers/customer/' + customerInfo.id,
                    {
                        method: 'PATCH',
                        headers: {
                            'machine':'2',
                            'vh-key':'7df7f81e-aaff-444c-a01c-8caeaeab3e61',
                            'content-type': 'application/json'
                        },
                        body: JSON.stringify({
                            is_active: false
                        }),
                    });

                if (!response.ok) {
                    throw new Error(`Failed to set customer inactive. Status: ${response.status}`);
                }

                setRecords((originalRecords) => originalRecords.map((record, index) => {
                    if (index !== recordIndex) {
                        return record;
                    }

                    return {
                        ...record,
                        is_active: false,
                    };
                }));
            } catch (error) {
                console.error(error);
            }
        }
    }

    const handleNewCustomer = () => {
        // new customer button clicked - create a generic empty customer object
        const newCustomer = {
                'customer_name': '',
                'contact_name': '',
                'contact_email': '',
                'config': {},
                'customer_type': 1
            };
        setCustomerEdit(newCustomer);
        setIsNewCustomer(true);
        setModalEdit(true);
      }

    const handleEditSubmit = (newRow) => {
        if (isNewCustomer) {
            // pull all data - refresh page
            window.location.reload()
            setIsNewCustomer(false)
        }
        else {
            // edited existing customer - update specific row
            fetchSingleCustomerData(records[editedRecord].id)
            setEditedRecord(null)
        }
      }

    const handleNotesSubmit = () => {
        //  handle any necessary logic after a new has been added
    }

    const showDelete = (record, recordIndex) => {
        // if the user has delete scope then show the delete icon
        if (canDeleteRecords) {
            return <BsFillTrashFill onClick={() => handleDeleteCustomer(record, recordIndex)} className='delete-btn' title='Remove this Customer' aria-label='Remove this Customer'/>
        }
    }

    const showEdit = (record, recordIndex) => {
        // if the user has edit scope then show the edit icon
        if (canEditRecords) {
            return <BsFillPencilFill onClick={() => handleCustomerEdit(record,recordIndex)} className='edit-btn' title='Edit Customer' aria-label='Edit Customer'/>
        }
    }

    const hasNotesPermission = (tokenPayload.scopes || []).some((scope) =>
        scope.startsWith('create:customerNotes') || scope.startsWith('update:customerNotes')
    );

    const canDeleteRecords =
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('delete:' + permissionScope));

    const canEditRecords =
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('update:' + permissionScope)) ||
        (tokenPayload.scopes || []).some((scope) => scope.startsWith('create:' + permissionScope));

    const canShowAnyActions = canDeleteRecords || canEditRecords;
    const visibleHeaders = canShowAnyActions ? headers : headers.filter((header) => header.KEY !== 'actions');

    const showCreateNew = () => {
        // if the user has create scope then show the Add New Customer button
        if ((tokenPayload.scopes || []).some((scope) => scope.startsWith('create:' + permissionScope))) {
            return (
                <Link className='btn customers-add-btn' onClick={() => handleNewCustomer()}>+ Add New Customer</Link>
            )
        }
    }

    function showDebug() {
        // var debugString = 'Sort Direction: ' + sort.direction + ' Sort Field: ' + sort.keyToSort;
        // // var debugString = sort.keyToSort === 'last_name' ? sort.direction : "asc"
        // return debugString
    }

    return (
        <div className='table-wrapper customers-page'>
            {/*<h3 className='left'>&emsp;&ensp;Customers{customerInfo !== null ? ": " + customerInfo.customer_name : ""} ({records.length})</h3>*/}
            <h3 className='page-title'>
                Customers <span className='page-count'>{visibleRecords.length}</span>
            </h3>
            <div>
                {showDebug()}
            </div>
            <div>
                {showCreateNew()}
            </div>
            <div className='customers-filter'>
                <div className='table-search-input-wrap'>
                    <input
                        type='text'
                        className='customers-search-input table-search-input'
                        value={searchText}
                        onChange={(event) => setSearchText(event.target.value)}
                        placeholder='Search customers'
                        aria-label='Search customers'
                    />
                    <button
                        type='button'
                        className='table-search-clear-icon'
                        onClick={() => setSearchText('')}
                        disabled={!searchText}
                        aria-label='Clear customer search'
                    >
                        x
                    </button>
                </div>
                {canDeleteRecords && (
                    <label className='customers-filter-label'>
                        <input
                            type='checkbox'
                            checked={showRemoved}
                            onChange={(event) => setShowRemoved(event.target.checked)}
                        />
                        Show Removed
                    </label>
                )}
            </div>
            <font size="3">
            <table className='table'>
                <thead>
                    <tr>
                        {visibleHeaders.map((header, index) => (
                            <th key={index} className={header.CLASS} onClick={() => handleHeaderClick(header)}>
                                {header.LABEL}
                                {header.KEY === sort.keyToSort && (
                                <Caret direction={sort.keyToSort === header.KEY ? sort.direction : "asc"}/>)}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {
                        isTableLoading ? (
                            Array.from({ length: 6 }).map((_, rowIndex) => (
                                <tr key={`customers-skeleton-${rowIndex}`} className='table-skeleton-row'>
                                    {visibleHeaders.map((header, cellIndex) => (
                                        <td key={`customers-skeleton-${rowIndex}-${header.KEY}-${cellIndex}`}>
                                            <span className={`table-skeleton-line${header.KEY === 'info' || header.KEY === 'actions' ? ' short' : ''}`} />
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            visibleRecords.map(({ record, recordIndex }) => {
                                return <tr key={recordIndex} onClick={(event) => handleCustomerView(record, event)}>
                                <td className='info-cell'>
                                    <span className='actions actions-three'>
                                        <BsFilePersonFill onClick={(event) => { event.stopPropagation(); handleViewCustomers(record); }} className='sessions-btn' title='Customer Clients' aria-label='Customer Clients'/>
                                        {hasNotesPermission && (
                                            <BsFileTextFill onClick={(event) => { event.stopPropagation(); handleViewNotes(record); }} className='sessions-btn' title='Customer Notes' aria-label='Customer Notes'/>
                                        )}
                                        <BsTable onClick={(event) => { event.stopPropagation(); handleViewSessions(record); }} className='sessions-btn' title='Show Session History' aria-label='Show Session History'/>
                                    </span>
                                </td>
                                <td className='left'>{record.id}</td>
                                <td className='left'>{record.customer_name}</td>
                                <td className='left'>{record.description}</td>
                                <td className='left'>{record.contact_name}</td>
                                <td className='left'>{record.contact_email}</td>
                                <td className='center'>{record.is_active ? "\u2714" : ""}</td>
                                <td className='center'>{record.is_authorized ? "\u2714" : ""}</td>
                                <td className='left'>{record.created_on ? format(new Date(record.created_on), 'MMM d, yyyy') : ''}</td>
                                {canShowAnyActions && (
                                    <td className='actions-cell'>
                                        <span className='actions'>
                                            {showEdit(record, recordIndex)}
                                            {showDelete(record, recordIndex)}
                                        </span>
                                    </td>
                                )}
                            </tr>
                            })
                        )}
                </tbody>
            </table>
            </font>
            {modalEdit && <ModalCustomerEdit closeModal={() => {
                setModalEdit(false)
                setIsReadOnlyModal(false)
            }}
                onSubmit={handleEditSubmit}
                customerEdit={customerEdit}
                isNewCustomer={isNewCustomer}
                allCustomerTypes={allCustomerTypes}
                allSportTeams={allSportTeams}
                allProtocols={allProtocols}
                isReadOnly={isReadOnlyModal}
            />}
            {modalSessions && <ModalCustomerSessions closeModal={() => {
                setModalSessions(false)
            }}
                customerIdSessions={customerIdSessions}
                isNewCustomer={isNewCustomer}
                customerInfo={customerInfo}
            />}
            {modalClients && <ModalCustomerClients closeModal={() => {
                setModalClients(false)
            }}
                customerIdClients={customerIdSessions}
                customerInfo={customerInfo}
            />}
            {modalNotes && <ModalCustomerNotes closeModal={() => {
                setModalNotes(false)
            }}
                onSubmit={handleNotesSubmit}
                customerInfo={customerInfo}
                isNewCustomer={isNewCustomer}
            />}
        </div>
  )
}

export default Customers



